import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AlertProvider } from './AlertContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const root = createRoot(document.getElementById('root'));
const queryClient = new QueryClient();
root.render(
  <QueryClientProvider client={queryClient}>
    <AlertProvider>
      <App />
    </AlertProvider>
  </QueryClientProvider>
);
